

















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditConfig from '@/components/profilExclusion/edit/EditConfig.vue'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import { TypeOffre } from '@/enum/TypeOffre'

@Component({
  name: 'ReadConfig',    
  components:{EditConfig},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    profilExclusion:{
      type:Object,
      default:getDefaultAloProfilExclusion()
    },  
    editable:{
      type:Boolean,
      default:true      
    } 
  }
})
export default class ReadConfig extends Vue {
  
  private profilExclusion!:AloProfilExclusion
  private loading!:boolean  
  private editable!:boolean  

  edit() { 
    (this.$refs.editConfig as EditConfig).edit(this.profilExclusion)
  }

}
